import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {
public registerUrl = 'https://arike.malonglobaltech.com/api/register';
public loginUrl = 'https://arike.malonglobaltech.com/api/login';

  constructor(
    public http: HttpClient
  ) { }

  async getUser(uid){
    // return this.afs.collection('users').doc(uid)
  }

 async register(obj){
   console.log(obj)
    // const token = await JSON.parse(localStorage.getItem('token'))
    return this.http.post(this.registerUrl, obj, {
      headers: new HttpHeaders({        
          'Content-Type':  'application/json',
          Accept: 'application/json',
          // Authorization: `Bearer ${token}`,
        }),
    })
  }

  async login(obj){
    // const token = await JSON.parse(localStorage.getItem('token'))
    return this.http.post(this.loginUrl, obj, {
      headers: new HttpHeaders({        
          'Content-Type':  'application/json',
          Accept: 'application/json',
          // Authorization: `Bearer ${token}`,
        }),
    })
  }
}
